import React, { useState } from 'react';
import { usePrecisionDashboard } from '../../Hooks/Features/Reports/usePrecisionDashboard';
import { useCommon } from "../../Hooks/Common/useCommon";
import { DataTable } from "primereact/datatable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Column } from 'primereact/column';
import { SkeletonContainer, SkeletonDataTable } from '../Loader/Loader'
import { Calendar } from 'primereact/calendar';
import CommonFilterDropdown from '../CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
const PrecisionDashboard = () => {

    const { checkPermission } = useCommon();
    const { tagRef, filterValues, setFilterValues, cardData, swotView, setSwotView, dataTableColumns, dataTableData, dataTableHeaderFooter, formatTeamEffortsCell, formatPrecisionCell, formatSwotCell, loader, handleMonthChange, getPrecisionReport, exportTeamEffortsToExcel, exportPrecisionSwotToExcel } = usePrecisionDashboard();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    return (
        <div ref={() => checkPermission("Precision Report", tagRef)}>
            <div ref={tagRef} id='{"tabname": "precision", "data": "precision_report_tab"}'>
                <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 mb-3 px-3">
                    <div className='d-flex align-items-center gap-2 c-pointer inspectra-calendar '>
                        <FontAwesomeIcon className='c-pointer' icon="fa-solid fa-backward-step" onClick={() => handleMonthChange(-1)} />
                        <Calendar
                            className='input-dd'
                            style={{ width: "150px" }}
                            value={filterValues?.date}
                            onChange={(e) => { handleMonthChange(0, e?.value) }}
                            dateFormat="MM yy"
                            view='month'
                        />
                        <FontAwesomeIcon className='c-pointer' icon="fa-solid fa-forward-step" onClick={() => handleMonthChange(+1)} />
                    </div>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <button className="sk-btn sk-btn-primary" onClick={() => getPrecisionReport()} title="Refresh">
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                        <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                            <FontAwesomeIcon icon="fa-solid fa-filter" />
                        </button>
                    </div>
                </div>

                {loader?.card ?
                    <div className='d-flex gap-3 mt-3 w100' style={{ height: "135px" }}>
                        {Array.from({ length: 4 }, (_, index) => (
                            <SkeletonContainer key={index} />
                        ))}
                    </div> :
                    <div className='d-flex gap-3 mt-3'>
                        <div className='position-relative w25'>
                            <div className='card-container precision-dashboard-card' style={{ borderTop: "25px solid #0984e3" }}>
                                <div className='position-absolute top-0 left-0 text-white p-1 fw-semibold'><FontAwesomeIcon icon="fa-solid fa-user" /> Employee</div>
                                <div className='fs-6 fw-semibold'>{cardData?.employee_data?.count}</div>
                                <div style={{ fontSize: "0.75rem" }}>Leads: {cardData?.employee_data?.leads} | Projects: {cardData?.employee_data?.projects}</div>
                            </div>
                        </div>
                        <div className='position-relative w25'>
                            <div className='card-container precision-dashboard-card' style={{ borderTop: "25px solid #00b894" }}>
                                <div className='position-absolute top-0 left-0 text-white p-1 fw-semibold'><FontAwesomeIcon icon="fa-solid fa-clock" /> Hours</div>
                                <div className='d-flex flex-column gap-1 p-1'>
                                    {cardData?.hours_data?.map((item, idx) => (
                                        <div key={idx} style={{ backgroundColor: item?.bg_color }} className='rounded px-1 d-flex align-items-center gap-2'>
                                            <div className='rounded' style={{ backgroundColor: item?.color, height: '10px', width: '10px' }}></div>
                                            <div className='fw-semibold'>{item?.name}</div>
                                            <div className='fw-semibold'>{item?.value}</div>
                                            <div className='align-self-end' style={{ fontSize: "0.65rem", color: "var(--text-color)", opacity: 0.7 }}>{item?.percentage}%</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='position-relative w25'>
                            <div className='card-container precision-dashboard-card' style={{ borderTop: "25px solid #fd79a8" }}>
                                <div className='position-absolute top-0 left-0 text-white p-1 fw-semibold'><FontAwesomeIcon icon="fa-solid fa-gauge" /> Performance</div>
                                {/* <div className='d-flex flex-column justify-content-center p-1'>
                                    {cardData?.performance_data?.map((item, idx) => (
                                        <div key={idx} className='d-flex gap-3 align-items-center'>
                                            <div>{item?.name}</div>
                                            <div className='w100 precision-dashoard-progress mt-1'><ProgressBar style={{ height: "8px" }} value={item?.value} className='rounded' /></div>
                                            <div style={{ fontSize: "0.7rem" }}>{item?.value}%</div>
                                        </div>
                                    ))}
                                </div> */}
                                <div className='text-center' style={{ position: 'relative' }}>
                                    <img src='./assets/nodata.jpg' alt='no data' style={{ width: '34%' }} />
                                    <p className='text-center red mt-2' style={{ fontSize: 'x-small' }}>
                                        Data Not Found
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='position-relative w25'>
                            <div className='card-container precision-dashboard-card' style={{ borderTop: "25px solid #6c5ce7" }}>
                                <div className='position-absolute top-0 left-0 text-white p-1 fw-semibold'><FontAwesomeIcon icon="fa-solid fa-shield-halved" /> Stability</div>
                                {/* <div className='d-flex flex-column justify-content-center p-1'>
                                    {cardData?.stability_data?.map((item, idx) => (
                                        <div key={idx} className='d-flex gap-3 align-items-center'>
                                            <div>{item?.name}</div>
                                            <div className='w100 precision-dashoard-progress mt-1'><ProgressBar style={{ height: "8px" }} value={item?.value} className='rounded' /></div>
                                            <div style={{ fontSize: "0.7rem" }}>{item?.value}%</div>
                                        </div>
                                    ))}
                                </div> */}
                                <div className='text-center' style={{ position: 'relative' }}>
                                    <img src='./assets/nodata.jpg' alt='no data' style={{ width: '34%' }} />
                                    <p className='text-center red mt-2' style={{ fontSize: 'x-small' }}>
                                        Data Not Found
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className='card-container mt-3'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='fs-6 ps-1 fw-semibold'>Team Efforts</div>
                        <div className='pe-1 c-pointer' title="Download Excel" onClick={() => exportTeamEffortsToExcel(!swotView)}>
                            <button className="sk-btn sk-btn-primary"><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /></button>
                        </div>
                    </div>
                    {loader?.efforts ? <div style={{ height: "41vh" }}><SkeletonDataTable numSkeletons={10} /></div> :
                        <DataTable value={dataTableData?.team_efforts?.data} headerColumnGroup={dataTableHeaderFooter?.teamEffortsHeaderGroup} footerColumnGroup={dataTableHeaderFooter?.teamEffortsFooterGroup} tableStyle={{ width: "max-content" }} className="precision-dashboard-dt" scrollable scrollHeight='41vh'>
                            <Column field="user_display_name" className='precision-employee-column' />
                            {
                                dataTableColumns?.team_efforts?.child?.map((value, index) => {
                                    return <Column key={index} field={value?.name} header={value?.name} body={(e) => formatTeamEffortsCell(e, value?.name)} className='view-border' />
                                })
                            }
                            <Column field='total' header="Total" body={(e) => formatTeamEffortsCell(e, "Total")} />
                        </DataTable>
                    }
                </div>

                <div className='card-container mt-3 mb-3'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='fs-6 ps-1 fw-semibold'>Precision / SWOT</div>
                        <div className='d-flex gap-2 align-items-center'>
                            <div className='pe-1 c-pointer' title={swotView ? "Switch to Precision view" : "Switch to SWOT view"} onClick={() => setSwotView(!swotView)}>
                                {swotView ? <FontAwesomeIcon icon="fa-solid fa-user-shield" /> : <FontAwesomeIcon icon="fa-solid fa-chart-bar" />}
                            </div>
                            <div className='pe-1 c-pointer' title="Download Excel" onClick={() => exportPrecisionSwotToExcel()}>
                                <button className="sk-btn sk-btn-primary"><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /></button>
                            </div>
                        </div>
                    </div>
                    {loader?.precision ? <div style={{ height: "41vh" }}><SkeletonDataTable numSkeletons={10} /></div> :
                        (swotView ?
                            <DataTable value={dataTableData?.swot} tableStyle={{ width: "max-content" }} className="precision-dashboard-dt" scrollable scrollHeight='41vh'>
                                <Column field="user_display_name" className='precision-employee-column' headerClassName='precision-employee-column' header="Employee" />
                                <Column field="swot" header="SWOT Remark" body={(e) => formatSwotCell(e)} style={{ width: "75vw" }} />
                            </DataTable>
                            : <DataTable value={dataTableData?.precision} headerColumnGroup={dataTableHeaderFooter?.precisionHeaderGroup} tableStyle={{ width: "max-content" }} className="precision-dashboard-dt" scrollable scrollHeight='41vh' rowGroupMode="rowspan" groupRowsBy="user_display_name"
                            >
                                <Column field="user_display_name" className='precision-employee-column' />
                                <Column field="project_name" />
                                {
                                    dataTableColumns?.precision?.child?.map((value, index) => {
                                        return <Column key={index} field={value?.name} header="View" body={(e) => formatPrecisionCell(e, value)} className='view-border' />
                                    })
                                }
                            </DataTable>)
                    }
                </div>

                {/* Right Panel Filters Drawer */}
                <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                    <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                        <div className="sk-drawer-header">
                            <h5 className="sk-drawer-title">Filters</h5>
                            <div className="d-flex align-items-center gap-2">
                                <button className="sk-drawer-clear-btn" onClick={() => {
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        project_leads: [],
                                        users: [],
                                        projects: [],
                                        technology: [],
                                        apiCall: true
                                    }));
                                }}>Clear All</button>
                                <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                    <FontAwesomeIcon icon="fa-solid fa-xmark" />
                                </button>
                            </div>
                        </div>
                        <div className="sk-drawer-body">
                            <div className='d-flex flex-column gap-4'>
                                {/* Dimensions Filter */}
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Dimensions</div>
                                    <CommonFilterDropdown
                                        fields={[
                                            { key: "project_leads", label: "Leads", col: 12 },
                                            { key: "users", label: "Users", col: 12 },
                                            { key: "projects", label: "Projects", col: 12 },
                                            { key: "technology", label: "Technology", col: 12 }
                                        ]}
                                        filterValues={filterValues}
                                        setFilterValues={setFilterValues}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="sk-drawer-footer">
                            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                                getPrecisionReport();
                                setShowFiltersDrawer(false);
                            }}>Apply Filters</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrecisionDashboard